import {useContext, useState} from 'react'
import {OrderAuditContext} from '../../context'
import OrderAuditArchivedNoteModal from '../modals/OrderAuditArchivedNoteModal'

const OrderAuditTableActionsMenu = ({row}: any) => {
  const {tabView, onUpdateStatus} = useContext(OrderAuditContext)
  const [showModal, setShowModal] = useState(false)
  const isArchivedTab = tabView === 'archived'

  const onChangeStatus = async () => {
    const payload = {
      is_archived: false,
      reason: null,
    }
    onUpdateStatus(row?.order_id, payload)
  }

  return [
    {
      label: `${isArchivedTab ? 'Activate' : 'Archive'}`,
      onClick: () => (!isArchivedTab ? setShowModal(true) : onChangeStatus()),
      render: !isArchivedTab && showModal && (
        <OrderAuditArchivedNoteModal row={row} onClose={() => setShowModal(false)} />
      ),
    },
  ]
}

export default OrderAuditTableActionsMenu
